import React from "react";
import AsyncAutoComplete from "./AsyncAutoComplete";

const SingleAsyncAutoComplete = ({
                                     fetch, value, label, field, required, handleOnChange, handleOnError = () => {
    }, ...autoCompleteProps
                                 }) => {
    return (
        <AsyncAutoComplete
            fetch={fetch}
            handleOnChange={handleOnChange}
            handleOnError={handleOnError}
            value={value}
            label={label}
            field={field}
            required={required}
            {...autoCompleteProps}
        />
    )
}

export default SingleAsyncAutoComplete;